import React from "react";

interface QuantityButtonInputProps {
  quantity: number;
  onChange: (value: number) => void;
  size?: number;
  detailPage?: boolean;
  variant?: "primary" | "subtle";
  minQuantity?: number;
}


const QuantityButtonInput: React.FC<QuantityButtonInputProps> = ({
  quantity,
  onChange,
  size = 28,
  detailPage = false,
  variant = "primary",
  minQuantity,
}) => {
  const isSubtle = variant === "subtle";
  const minimumQuantity = typeof minQuantity === "number" ? minQuantity : (detailPage ? 1 : 0);
  // 사이드 버튼 크기 = size. 컨테이너는 그에 맞춰 비례 확장.
  const SIDE_BTN_SIZE = size;
  const FIXED_HEIGHT = SIDE_BTN_SIZE + 8;
  const FIXED_WIDTH = SIDE_BTN_SIZE * 3 + 24;

  // 카드 리스트 — 수량 0: [+ 담기] 버튼
  if (!detailPage && quantity === 0 && minQuantity === undefined) {
    return (
      <button
        type="button"
        className="flex items-center justify-center gap-1 font-bold text-white active:opacity-75 transition-opacity"
        style={{
          width: `${FIXED_WIDTH}px`,
          height: `${FIXED_HEIGHT}px`,
          borderRadius: "999px",
          backgroundColor: "#e16036",
          fontSize: "15px",
          fontFamily: "Gmarket-M, sans-serif",
          flexShrink: 0,
          //   boxShadow: "0 4px 12px rgba(225, 96, 54, 0.45), 0 1px 3px rgba(225, 96, 54, 0.3)",
        }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onChange(1);
        }}
      >
        담기
      </button>
    );
  }

  const isMinDisabled = quantity <= minimumQuantity;

  const activeColor = isSubtle ? "#111" : "#e16036";

  const baseBtnStyle: React.CSSProperties = {
    width: `${SIDE_BTN_SIZE}px`,
    height: `${SIDE_BTN_SIZE}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    border: "none",
    backgroundColor: "transparent",
    color: activeColor,
    fontWeight: isSubtle ? 400 : 700,
    fontSize: "18px",
    cursor: "pointer",
    flexShrink: 0,
    lineHeight: 1,
    transition: "background 0.1s",
  };

  const minusBtnStyle: React.CSSProperties = {
    ...baseBtnStyle,
    color: isMinDisabled ? "#d1d5db" : activeColor,
    cursor: isMinDisabled ? "not-allowed" : "pointer",
  };

  const hoverClass = isSubtle
    ? "hover:bg-gray-100 active:bg-gray-200 transition-colors"
    : "hover:bg-orange-50 active:bg-orange-100 transition-colors";

  return (
    <div
      className="flex items-center justify-between"
      style={{
        width: `${FIXED_WIDTH}px`,
        height: `${FIXED_HEIGHT}px`,
        borderRadius: isSubtle ? "8px" : "999px",
        border: isSubtle ? "1px solid #d1d5db" : "2px solid #e16036",
        backgroundColor: "#fff",
        padding: "0 6px",
        flexShrink: 0,
      }}
    >
      {/* 빼기 / 쓰레기통 */}
      <button
        type="button"
        style={minusBtnStyle}
        className={isMinDisabled ? "" : hoverClass}
        disabled={isMinDisabled}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          if (quantity > minimumQuantity) {
            onChange(quantity - 1);
          }
        }}
      >
        <span style={{ marginTop: "-2px" }}>−</span>
      </button>

      {/* 수량 */}
      <span
        style={{
          minWidth: "28px",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 700,
          color: "#111",
          fontFamily: "Gmarket-B, sans-serif",
        }}
      >
        {quantity}
      </span>

      {/* 더하기 */}
      <button
        type="button"
        style={baseBtnStyle}
        className={hoverClass}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onChange(quantity + 1);
        }}
      >
        <span style={{ marginTop: "-2px" }}>+</span>
      </button>
    </div>
  );
};

export default QuantityButtonInput;
